import { apiFetch } from './client'
import type { Customer } from './types'

export const customersApi = {
  list: (token: string) =>
    apiFetch<Customer[]>('/customers', token),

  create: (token: string, data: { customer_name: string; tenant_id?: string }) =>
    apiFetch<Customer>('/customers', token, {
      method: 'POST',
      body: JSON.stringify(data),
    }),

  rename: (token: string, customerId: string, newName: string) =>
    apiFetch<{ status: string }>(`/customers/${customerId}`, token, {
      method: 'PATCH',
      body: JSON.stringify({ customer_name: newName }),
    }),

  delete: (token: string, customerId: string) =>
    apiFetch<void>(`/customers/${customerId}`, token, { method: 'DELETE' }),

  regenerateKey: (token: string, customerId: string) =>
    apiFetch<{ key: string }>(`/customers/${customerId}/regenerate-key`, token, {
      method: 'POST',
    }),
}
